import { Table, TableContainer, alpha } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ApprovalTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: 16,
  padding: 12,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.background.header,
  borderRadius: 12,
}))

export const ApprovalTable = styled(Table)(({ theme }) => ({
  marginTop: 4,
  padding: 4,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.background.header,
}))

export const tableCellStyles = (theme: any, color?: any, _item?: any) => ({
  fontWeight: 500,
  fontSize: 13,
  backgroundColor: alpha(theme.palette.text.primary, 0.02),
  color: color || theme.palette.text.primary,
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  textAlign: 'left' as const,
  fontVariantNumeric: 'tabular-nums' as const,
})

export const descriptionCellStyles = (theme: any, color?: any, _item?: any) => ({
  display: 'flex',
  flexDirection: 'row' as const,
  height: '100%',
  fontWeight: 500,
  fontSize: 13,
  backgroundColor: alpha(theme.palette.text.primary, 0.02),
  color: color || theme.palette.text.primary,
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  textAlign: 'left' as const,
})

export const tableRowStyles = (theme: any) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'transparent' : alpha(theme.palette.background.paper, 0.6),
})

export const tableHeaderStyles = (theme: any) => ({
  fontWeight: 700,
  fontSize: 10,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  backgroundColor: alpha(theme.palette.text.primary, 0.03),
  textAlign: 'left' as const,
  color: theme.palette.text.secondary,
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
})

export const tableSectionStyles = (theme: any) => ({
  fontWeight: 700,
  fontSize: 14,
  color: theme.palette.text.primary,
})

export const tableKeyStyles = (theme: any) => ({
  fontWeight: 600,
  fontSize: 11,
  backgroundColor: theme.palette.mode === 'dark' ? 'transparent' : alpha(theme.palette.background.paper, 0.8),
  color: theme.palette.text.secondary,
  textAlign: 'left' as const,
})

export const infoTableContainerStyles = (theme: any) => ({
  fontWeight: 500,
  borderRadius: '12px',
  minHeight: '330px',
  textAlign: 'left' as const,
  color: theme.palette.text.secondary,
  border: '1px solid',
  borderColor: theme.palette.divider,
  bgcolor: theme.palette.mode === 'dark' ? alpha(theme.palette.text.primary, 0.02) : theme.palette.background.paper,
})

export const infoTableHeaderStyles = (theme: any) => ({
  fontSize: 10,
  fontWeight: 700,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
})

export const infoTableTextStyles = (theme: any) => ({
  fontSize: 13,
  fontWeight: 500,
  color: theme.palette.text.primary,
  fontVariantNumeric: 'tabular-nums' as const,
})
